export default (utcDateTime: string): string => {
    const utc = new Date(utcDateTime);
    return (
        utc.getFullYear() +
        '-' +
        leadingZero(utc.getMonth() + 1) +
        '-' +
        leadingZero(utc.getDate()) +
        ' ' +
        leadingZero(utc.getHours()) +
        ':' +
        leadingZero(utc.getMinutes()) +
        ':' +
        leadingZero(utc.getSeconds())
    );
};

const leadingZero = (value: number): string => (value < 10 ? '0' + value : value.toString());



// WEBPACK FOOTER //
// ./src/view/admin/integration/utcToLocalTime.ts